import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GuardianService } from 'src/app/_services/guardian.service';
import { Subscription } from '../../_models/subscription';
import { StudentService } from '../../_services/student.service';

@Component({
  selector: 'app-student-home-show',
  templateUrl: './student-home-show.component.html',
  styleUrls: ['./student-home-show.component.css']
})
export class StudentHomeShowComponent implements OnInit {

  server_student_user_id:0
  subscription= new Subscription()
  loading=false
  pendingStandardQuizCount=undefined
  pendingTrivialQuizCount=undefined
  maskedGift:any=undefined
  learner:any=undefined
  guardian :any=undefined
  constructor(
    private studentService:StudentService,
    private guardianService:GuardianService,
    private activatedRoute: ActivatedRoute) {

   }
  ngOnInit(): void {
    this.loading=true
    this.activatedRoute.params.subscribe(
      myParams => {
        this.server_student_user_id = myParams['server_student_user_id']
        this.initGifting()
        this.initStudent()
        })
        this.guardian= this.guardianService.guardianSubject.getValue()
  }
  initPendingCount(){
    this.studentService.getWebPendingQuizCount(this.server_student_user_id).subscribe(
      xx=>{
        this.pendingStandardQuizCount=xx['STANDARD']
        this.pendingTrivialQuizCount=xx['TRIVIAL']

      }
    )
  }
  initGifting(){
    this.studentService.getGiftingInformation(this.server_student_user_id).subscribe(
      myMaskedGift=>{
        this.maskedGift=myMaskedGift
      }
    )
  }
initStudent(){
  this.studentService.getLearner(this.server_student_user_id).subscribe(
    learner=>{
      this.studentService.minStudentData.next(learner)
      this.loading=false
      this.learner=learner
      this.subscription=learner['subscription_object']
    }
  )
  this.initPendingCount()
}




}
